import * as React from "react";

function SvgPreference(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.438 2.96h4.915s1.178 0 1.178 1.45c0 1.448-1.178 1.448-1.178 1.448h-4.915a4.383 4.383 0 01-4.133 2.898 4.383 4.383 0 01-4.134-2.898H1.353s-.884 0-.884-1.449.884-1.449.884-1.449H21.17A4.383 4.383 0 0125.305.063a4.383 4.383 0 014.133 2.897zM34.353 14.551H11.907a4.383 4.383 0 00-4.134-2.898 4.383 4.383 0 00-4.133 2.898H1.353s-.884 0-.884 1.449.884 1.449.884 1.449H3.64a4.383 4.383 0 004.133 2.898 4.383 4.383 0 004.134-2.898h22.446s1.178 0 1.178-1.449-1.178-1.449-1.178-1.449zM23.594 26.142h10.759s1.178 0 1.178 1.449-1.178 1.449-1.178 1.449H23.594a4.383 4.383 0 01-4.133 2.898 4.383 4.383 0 01-4.134-2.898H1.353s-.884 0-.884-1.45c0-1.448.884-1.448.884-1.448h13.974a4.383 4.383 0 014.134-2.898 4.383 4.383 0 014.133 2.898z"
        fill="#FEFEFE"
      />
    </svg>
  );
}

export default SvgPreference;
